module.exports = __webpack_public_path__ + "static/media/register-page-image.c7c0fabb.jpeg";